import React from 'react';
import Feature from '../feature/Feature';
import { Icons } from '../../../../assets/icons';
import type { paths } from '../../../../endpoint/Schema';
import { Dropdown } from 'primereact/dropdown';

interface LanguageFeatureProps {
  featureSettings:
    | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
    | undefined;
  setFeatureSettings: React.Dispatch<
    React.SetStateAction<
      | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
      | undefined
    >
  >;
}

const languageOptions = [
  { label: 'English', value: 'EnGb' },
  { label: 'Spanish', value: 'EsEs' },
  { label: 'Italian', value: 'ItIt' },
];

function LanguageFeature({
  featureSettings,
  setFeatureSettings,
}: LanguageFeatureProps) {
  const handleLanguageChecked = (checked: boolean) => {
    setFeatureSettings((prev) => ({
      ...prev,
      languageSettings: {
        ...prev?.languageSettings,
        enabled: checked,
        language: prev?.languageSettings?.language ?? 'EnGb',
      },
    }));
  };

  const handleLanguageChange = (value: 'EnGb' | 'EsEs' | 'ItIt') => {
    setFeatureSettings((prev) => ({
      ...prev,
      languageSettings: {
        ...prev?.languageSettings,
        language: value,
      },
    }));
  };

  return (
    <Feature
      icon={Icons.ic_language}
      image="img_insight" // Using insight image as placeholder
      title="Language"
      description="Enable multi-language support for your application. Users can switch between English and Spanish interfaces to improve accessibility and user experience."
      checked={featureSettings?.languageSettings?.enabled ?? false}
      onChange={handleLanguageChecked}
    >
      {featureSettings?.languageSettings?.enabled && (
        <div className="mt-5 mb-6 flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-gray-700 min-w-[100px]">
              Default Language:
            </label>
            <Dropdown
              value={featureSettings?.languageSettings?.language ?? 'EnGb'}
              options={languageOptions}
              onChange={(e) => {
                handleLanguageChange(e.value);
              }}
              placeholder="Select Language"
              className="w-48"
            />
          </div>
        </div>
      )}
    </Feature>
  );
}

export default LanguageFeature;
